import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "filter__title"
};
const _hoisted_2 = { class: "filter__list filter-list" };
const _hoisted_3 = ["checked", "onChange"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FilterList = _resolveComponent("FilterList", true);
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(`filter filter--${_ctx.taxonomy}`)
    }, [
        (_ctx.title !== null)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_ctx.title), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
        _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.terms, (t) => {
                return (_openBlock(), _createElementBlock("li", {
                    key: `term-${t.id}`,
                    class: _normalizeClass(["filter-list__item", { 'permalink-list__item--active': _ctx.selectedTerms.has(t.id) }])
                }, [
                    _createElementVNode("label", null, [
                        _createElementVNode("input", {
                            checked: _ctx.selectedTerms.has(t.id),
                            onChange: ($event) => (_ctx.handleChange($event, t)),
                            type: "checkbox"
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3),
                        _createTextVNode(" " + _toDisplayString(t.name), 1 /* TEXT */)
                    ]),
                    (t.children.length > 0 && (_ctx.maxDepth === null || _ctx.maxDepth > _ctx.depth))
                        ? (_openBlock(), _createBlock(_component_FilterList, {
                            key: `term-${t.id}`,
                            taxonomy: _ctx.taxonomy,
                            terms: t.children,
                            selectedTerms: _ctx.selectedTerms,
                            toggleCb: _ctx.toggleCb,
                            depth: _ctx.depth + 1,
                            maxDepth: _ctx.maxDepth
                        }, null, 8 /* PROPS */, ["taxonomy", "terms", "selectedTerms", "toggleCb", "depth", "maxDepth"]))
                        : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */));
            }), 128 /* KEYED_FRAGMENT */))
        ])
    ], 2 /* CLASS */));
}
